export default "__VITE_ASSET__CtYdn_Mv__"